import { ExclamationCircleFilled } from '@ant-design/icons';
import React from 'react';

type Props = {
  classNames: string;
  error: string;
  iconSize?: string;
  iconColor?: string;
};

export const KlaviyoErrorMessage = ({
  classNames,
  error,
  iconColor = '#faad14',
  iconSize = '14px',
}: Props) => (
  <div className={classNames}>
    <ExclamationCircleFilled style={{ color: iconColor, fontSize: iconSize }} />
    {error}
  </div>
);
